import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import { ShippingQuoteGroups } from "../interfaces/shipping-quote/ShippingQuoteGroup";

export default function shippingQuotesReducer(state: ShippingQuoteGroups = [], action: Action) {
    switch (action.type) {
        case ActionTypeEnum.SHIPPING_QUOTES_SET:
            return action.quotes;
        default:
            return state;
    }
}
